const animateLoader = (e, array, offset, step, type, isLoading) => {
  if (step === 1) {
    array += 3.6;
    if (array >= 45) {
      array = 45; // clamp to maximum
      step = 2;
    }
  }

  if (step === 2) {
    array += 2;
    offset -= 5.4;
    if (array >= 90) {
      array = 90; // clamp to maximum
      step = 3;
    }
  }

  if (step === 3) {
    array -= 7.2;
    if (array <= 1) {
      array = 1; // clamp to minimum
      step = 1;
    }
  }

  if (type === "button") {
    if (e && isLoading) {
      e.style.cssText = `stroke-dasharray: ${array}, 200; stroke-dashoffset: ${offset}px`;
    } else {
      step = 0;
    }
  } else if (e) {
    e.style.cssText = `stroke-dasharray: ${array}, 200; stroke-dashoffset: ${offset}px`;
  } else {
    step = 0;
  }

  // We need to start next looping when the step was changed
  if (step === 1) {
    setTimeout(() => {
      animateLoader(e, array, 0, 1, type, isLoading);
    }, 16.2);
  } else if (step === 2) {
    setTimeout(() => {
      animateLoader(e, array, offset, 2, type, isLoading);
    }, 22);
  } else if (step === 3) {
    setTimeout(() => {
      animateLoader(e, array, offset, 3, type, isLoading);
    }, 16.2);
  }
};

export default animateLoader;
